// App.js
import { useEffect, useState } from "react";
import React from 'react';
import { Box, Tooltip } from "@mui/material";
import CustomTextField from "../../../main/widgets/CustomTextField";
import { FormControl, Typography } from "@mui/joy";
import NativeCheckbox from "../../../main/components/NativeCheckbox";
import Grid from '@mui/joy/Grid';
import Button from '@mui/joy/Button';
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import CustomerOptionList from "../../../main/widgets/CustomersOptionList";
import Snackbar from '@mui/joy/Snackbar';
import axios from "axios";
import ShipmentSticker from "./ShipmentSticker";
import { apiURL } from "../../../main/API/constants";
import { sendWhatsAppShipmentNotification } from "../../../main/API/whatsapp";
import ShipmentTypeOptionList from "../../../main/widgets/ShipmentTypeOptionList";
import { DataGrid } from "@mui/x-data-grid";
import { formatTime } from "../../../main/services/format";
import { getShipmentFormPaymentColumns } from "../../../main/widgets/shipmentPaymentDataGridColumns";
import SendIcon from '@mui/icons-material/Send';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PaidOptionList from "../../../main/widgets/PaidOptionList";
import LocationOptionList from "../../../main/widgets/LocationOptionList";
import StatusOptionList from "../../../main/widgets/StatusOptionList";
import OmrSymbol from '../../../main/components/OmrSymbol';
import PermissionGate from '../../../main/components/PermissionGate';
import { PERMISSIONS } from '../../../main/context/AuthContext';
import { usePermissions } from '../../../main/hooks/usePermissions';

export default function PendingShipmentForm({ formType, shipmentID }) {
  const { hasPermission } = usePermissions();
  const { t } = useTranslation('ui');
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(false);

  //control values

  //Snackbar controller
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [successSentMsg, setSuccessSentMsg] = useState(false);
  const [failedUpdate, setFailedUpdate] = useState(false);
  const [failedSentMsg, setFailedSentMsg] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  //Form Values
  const [id, setId] = useState("");
  const [shipperReference, setShipperReference] = useState("");
  const [trackingNumber, setTrackingNumber] = useState("");
  const [itemsDescription, setItemsDescription] = useState("");
  const [packagesQuantity, setPackagesQuantity] = useState("");
  const [weight, setWeight] = useState("");
  const [width, setWidth] = useState("");
  const [length, setLength] = useState("");
  const [height, setHeight] = useState("");
  const [charge, setCharge] = useState("");
  const [volumetricWeight, setVolumetricWeight] = useState("");
  const [price, setPrice] = useState("");
  const [currentLocation, setCurrentLocation] = useState("");
  const [note, setNote] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [shipmentOwner, setShipmentOwner] = useState(null);
  const [paid, setPaid] = useState("");
  const [calculatePrice, setCalculatePrice] = useState(true);
  const [pricingTariffCode, setPricingTariffCode] = useState("");
  const [productCategoryCode, setProductCategoryCode] = useState("");
  const [meterPriceOverride, setMeterPriceOverride] = useState("");
  const [extraCost, setExtraCost] = useState("");
  const [transactionDate, setTransactionDate] = useState("");


  //shipment for edit and view form
  const [shipment, setShipment] = useState("");



  function notificationStatusIcon(notificationStatus) {
    console.log(notificationStatus);
    if (notificationStatus == 'sent') {
      return (<Tooltip title={"Success"}><SendIcon color="success">Sent</SendIcon></Tooltip>)
    }
    else {
      return (<Tooltip title={"Failed to send"}><CancelScheduleSendIcon color="error">Failed</CancelScheduleSendIcon></Tooltip>)

    }
  }

  const columns = [
    { field: 'shipment_status', headerName: 'Shipment Status', flex: 2 },
    { field: 'channel', headerName: 'Channel', flex: 2, renderCell: (params) => (<WhatsAppIcon color="success" ></WhatsAppIcon>) },
    { field: 'notification_status', headerName: 'Notification Status', flex: 2, renderCell: (params) => notificationStatusIcon(params.row.notification_status) },

    { field: 'created_at', headerName: 'Created At', flex: 2, renderCell: (params) => formatTime(params.row.created_at) },
  ];



  //submit form 
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (id == "") {
      if (!hasPermission(PERMISSIONS.SHIPMENTS_CREATE)) return;
    } else if (!hasPermission(PERMISSIONS.SHIPMENTS_UPDATE)) {
      return;
    }

    setLoading(true);

    //add new shipment 
    if (id == "") {
      await addShipment(("%2B968"), {});

    }
    //update existing shipment
    else {
      await updateShipment();

    }

    setLoading(false);
  }


  function FillAllVariables(shipment) {
    setId(shipment.id);
    setShipperReference(shipment.shipper_reference);
    setTrackingNumber(shipment.tracking_number);
    setItemsDescription(shipment.items_description);
    setPackagesQuantity(shipment.packages_quantity);
    setWeight(shipment.weight);
    setWidth(shipment.width_cm);
    setLength(shipment.length_cm);
    setHeight(shipment.height_cm);
    setCharge(shipment.charge);
    setVolumetricWeight(shipment.volumetric_weight)
    setPrice(shipment.price);
    setCurrentLocation(shipment.current_location);
    setNote(shipment.note);
    setStatus(shipment.status);
    setShipmentOwner(shipment.owner);
    setShipment(shipment);
    setPaid(shipment.paid);
    setCalculatePrice(shipment.auto_calculating_price);
    setType(shipment.type);
    setPricingTariffCode(
      shipment.pricing_tariff_code != null ? String(shipment.pricing_tariff_code) : ""
    );
    setProductCategoryCode(
      shipment.product_category_code != null ? String(shipment.product_category_code) : ""
    );
    setMeterPriceOverride(
      shipment.meter_price_override != null ? String(shipment.meter_price_override) : ""
    );
    setExtraCost(shipment.extra_cost != null ? String(shipment.extra_cost) : "");
    setNotifications(shipment.notifications);
    if (shipment.transaction_date != null && shipment.transaction_date !== "") {
      const s = String(shipment.transaction_date);
      setTransactionDate(s.length >= 10 ? s.slice(0, 10) : s);
    } else {
      setTransactionDate("");
    }
  }


  //TODO: Check if good idea to create customer then assine to the customer the shipment, this will cause adding a lot customers with no data only phone number
  //Add shipment to the database with the owner number
  const addShipment = async (data) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    // POST request using axios with error handling
    axios.post(`${apiURL}/gofar/shipment/`, {
      owner: shipmentOwner.id,
      shipper_reference: shipperReference,
      tracking_number: trackingNumber,
      items_description: itemsDescription,
      packages_quantity: packagesQuantity,
      weight: weight,
      width_cm: width,
      length_cm: length,
      height_cm: height,
      volumetric_weight: volumetricWeight,
      charge: charge,
      price: price,
      auto_calculating_price: calculatePrice,
      current_location: currentLocation,
      note: note,
      status: status,
      type: type,
      paid: paid,
      pricing_tariff_code: String(pricingTariffCode ?? "").trim() || null,
      product_category_code: String(productCategoryCode ?? "").trim() || null,
      meter_price_override:
        meterPriceOverride !== "" && meterPriceOverride != null
          ? String(meterPriceOverride).trim()
          : null,
      extra_cost:
        extraCost !== "" && extraCost != null ? String(extraCost).trim() : null,
      transaction_date: transactionDate && String(transactionDate).trim() !== "" ? String(transactionDate).trim().slice(0, 10) : null,
    },
      {
        headers:
          { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    )
      .then(async response => {
        console.log(response.headers.get('content-type')?.includes('application/json'));
        const isJson = response.headers.get('content-type')?.includes('application/json');
        console.log(response.status);

        // check for error response
        if (response.status != 201) {
          console.log("response is not OK")
          // get error message from body or default to response status
          const error = (data && data.message) || response.status;
          //return Promise.reject(error);
        }
        //if post shipment is successful
        else {
          //resetAllVariables();
          window.location.href = "/shipment/" + response.data.id + "/EditShipment";

        }
      })
      .catch(error => {
        console.log(error);
        this.setState({ errorMessage: error.toString() });
        console.error('There was an error!', error);
      });
  }

  //update shipment in the database with the owner number
  const updateShipment = async (data) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    axios.put(`${apiURL}/gofar/shipment/` + id + "/", {
      id: id,
      owner: shipmentOwner.id,
      shipper_reference: shipperReference,
      tracking_number: trackingNumber,
      items_description: itemsDescription,
      packages_quantity: packagesQuantity,
      weight: weight,
      width_cm: width,
      length_cm: length,
      height_cm: height,
      volumetric_weight: volumetricWeight,
      charge: charge,
      price: price,
      auto_calculating_price: calculatePrice,
      current_location: currentLocation,
      note: note,
      status: status,
      type: type,
      paid: paid,
      pricing_tariff_code: String(pricingTariffCode ?? "").trim() || null,
      product_category_code: String(productCategoryCode ?? "").trim() || null,
      meter_price_override:
        meterPriceOverride !== "" && meterPriceOverride != null
          ? String(meterPriceOverride).trim()
          : null,
      extra_cost:
        extraCost !== "" && extraCost != null ? String(extraCost).trim() : null,
      transaction_date: transactionDate && String(transactionDate).trim() !== "" ? String(transactionDate).trim().slice(0, 10) : null,
    },
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      })
      .then(async response => {
        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson && await response.data != null;

        // check for error response
        if (response.status != 200) {
          console.log("response is not OK")
          console.log(response);
          // get error message from body or default to response status
          const error = (data && data.message) || response.status;

          //Show failed notification
          setFailedUpdate(true);
          setErrorMessage(error);

        }
        //if post shipment is successful
        else {
          //update all variables
          setShipment(response.data);

          //update all variables 
          FillAllVariables(response.data);
          console.log(response.data);

          //Show notification
          setSuccessUpdate(true);

        }
      })
      .catch(error => {
        setFailedUpdate(true);
        setErrorMessage(error);
      });
  }

  const getShipment = async (shipmentID) => {
    if (!hasPermission(PERMISSIONS.SHIPMENTS_VIEW)) return;
    setLoading(true);
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    axios.get(`${apiURL}/gofar/shipment/` + shipmentID + "/",
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      })
      .then((response) => response.data)
      .then((actualData) => {

        FillAllVariables(actualData);
        setShipment(actualData);
        console.log(actualData);

      })
      .catch((err) => {
        console.log(err.message);
        setLoading(false);
      });
    setLoading(false);
  };

  const sendWhatsAppMessage = async (shipmentID) => {
    if (!hasPermission(PERMISSIONS.WHATSAPP_SEND_SHIPMENT_NOTIFICATION)) return;
    try {

      setLoadingMsg(true);
      const messageSID = await sendWhatsAppShipmentNotification(shipmentID).then(async response => {
        //message send successfully
        if (response.status == 200) {
          setSuccessSentMsg(true);
        }
        //failed
        else {
          setSuccessSentMsg(false);
        }

      });



    }
    catch (e) {
      setLoadingMsg(false);
    }
    setLoadingMsg(false);


  }


  useEffect(() => {
    if (shipmentID != null) {
      getShipment(shipmentID);
    }

  }, []);

  return (
    <Box m={5}>
      <Box>
        <form onSubmit={handleSubmit}>
          <FormControl>
            <Typography marginBottom={5}>
              <Typography level="h1">{"Shipment Request"}</Typography>
            </Typography>
            <Grid container spacing={2} sx={{ flexGrow: 1 }}>
              <Grid display={formType === "edit" ? "block" : "none"} xs={12} sm={6} md={4}>
                <CustomTextField display={formType === "edit" ? "block" : "none"} disabled={true} type="text" onChange={(event) => setId(event.target.value)} value={id} label={"Shipment ID"}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                {/* Third-party tracking number is optional. */}
                <CustomTextField type="text" onChange={(event) => setTrackingNumber(event.target.value)} value={trackingNumber} label={"Third-party tracking number"}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <CustomTextField type="text" onChange={(event) => setShipperReference(event.target.value)} value={shipperReference} label={"Shipper Reference"}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <CustomTextField
                  type="date"
                  onChange={(event) => setTransactionDate(event.target.value)}
                  value={transactionDate}
                  label="Transaction date"
                />
              </Grid>
              <Grid xs={12} sm={9} md={6}>
                <CustomTextField type="text" onChange={(event) => setItemsDescription(event.target.value)} value={itemsDescription} label={"Items Description"}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={3} md={2}>
                <CustomTextField slotProps={{
                  input: {
                    min: 1,
                    max: 1000
                  },
                }} required={true} type="number" onChange={(event) => setPackagesQuantity(event.target.value)} value={packagesQuantity} label={"Packages Quantity"} endDecorator={"piece"}></CustomTextField>
              </Grid>
              <Grid xs={12}>
                <br></br>
              </Grid>
              <Grid xs={12} sm={4} md={2}>
                <CustomTextField slotProps={{
                  input: {
                    min: 0,
                    max: 999999999999999,
                    step: 0.001,
                  },
                }} required={true} type="number" onChange={(event) => setVolumetricWeight(event.target.value)} value={volumetricWeight} label={"Volumetric Weight"} endDecorator={""}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={4} md={2}>
                <CustomTextField slotProps={{
                  input: {
                    min: 0,
                    max: 999999999999999,
                    step: 0.001,
                  },
                }} type="number" onChange={(event) => setCharge(event.target.value)} value={charge} label={"Charge"} endDecorator={<OmrSymbol height={16} />}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={4} md={2}>
                <CustomTextField slotProps={{
                  input: {
                    min: 0,
                    max: 999999999999999,
                    step: 0.001,
                  },
                }} type="number" onChange={(event) => setWidth(event.target.value)} value={width} label={"Width (cm)"} endDecorator={"cm"}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={4} md={2}>
                <CustomTextField slotProps={{
                  input: {
                    min: 0,
                    max: 999999999999999,
                    step: 0.001,
                  },
                }} type="number" onChange={(event) => setLength(event.target.value)} value={length} label={"Length (cm)"} endDecorator={"cm"}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={4} md={2}>
                <CustomTextField slotProps={{
                  input: {
                    min: 0,
                    max: 999999999999999,
                    step: 0.001,
                  },
                }} type="number" onChange={(event) => setHeight(event.target.value)} value={height} label={"Height (cm)"} endDecorator={"cm"}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={4} md={2}>
                <CustomTextField slotProps={{
                  input: {
                    min: 0,
                    max: 999999999999999,
                    step: 0.001,
                  },
                }} type="number" onChange={(event) => setWeight(event.target.value)} value={weight} label={"Weight"} endDecorator={"kg"}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <CustomTextField slotProps={{
                  input: {
                    min: 0,
                    max: 999999999999999,
                    step: 0.001,
                  },
                }} type="number" onChange={(event) => setPrice(event.target.value)} value={price} label={"Price"} endDecorator={<OmrSymbol height={16} />} disabled={calculatePrice}></CustomTextField>
              </Grid>
              <Grid xs={12} sm={6} md={4} marginTop={3.5}>
                <NativeCheckbox defaultChecked={calculatePrice} checked={calculatePrice} onChange={(event) => setCalculatePrice(event.target.checked)} label="Calculate price" />
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <PaidOptionList
                  label="Payment Status"
                  required={true}
                  paid={paid}
                  setPaid={(newValue) => setPaid(newValue)}
                />
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <LocationOptionList
                  label="Current Location"
                  required={true}
                  currentLocation={currentLocation}
                  setCurrentLocation={(newValue) => setCurrentLocation(newValue)}
                  showAll={false}
                  disabled={false}
                />
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <StatusOptionList
                  required={true}
                  status={status}
                  setStatus={(newValue) => setStatus(newValue)}
                  showAll={false}
                  disabled={false}
                />
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <ShipmentTypeOptionList defaultValue={type} required={true} onChange={(event, value) => setType(value?.id ?? value)}></ShipmentTypeOptionList>
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <CustomTextField type="text" onChange={(event) => setNote(event.target.value)} value={note} label={"Note"}></CustomTextField>
              </Grid>
              <Grid xs={12} marginTop={3}>
                <CustomerOptionList defaultValue={shipmentOwner} required={true} onChange={(event, value) => setShipmentOwner(value)}> </CustomerOptionList>
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <CustomTextField
                  type="text"
                  label={t('shipmentForm.pricingTariffCode')}
                  value={pricingTariffCode}
                  onChange={(e) => setPricingTariffCode(e.target.value)}
                />
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <CustomTextField
                  type="text"
                  label={t('shipmentForm.productCategoryCode')}
                  value={productCategoryCode}
                  onChange={(e) => setProductCategoryCode(e.target.value)}
                />
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <CustomTextField
                  slotProps={{ input: { min: 0, step: 0.001 } }}
                  type="number"
                  label={t('shipmentForm.meterPriceOverride')}
                  value={meterPriceOverride}
                  onChange={(e) => setMeterPriceOverride(e.target.value)}
                  endDecorator={<OmrSymbol height={16} />}
                />
              </Grid>
              <Grid xs={12} sm={6} md={4}>
                <CustomTextField
                  slotProps={{ input: { min: 0, step: 0.001 } }}
                  type="number"
                  label={t('shipmentForm.extraCost')}
                  value={extraCost}
                  onChange={(e) => setExtraCost(e.target.value)}
                  endDecorator={<OmrSymbol height={16} />}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ flexGrow: 1 }}>
              <Grid xs={12} sm={8}>
                {formType === "edit" ? (
                  <PermissionGate permission={PERMISSIONS.SHIPMENTS_UPDATE}>
                    <Box marginTop={5}>
                      <Button loading={isLoading} type="submit">Update</Button>
                    </Box>
                  </PermissionGate>
                ) : (
                  <PermissionGate permission={PERMISSIONS.SHIPMENTS_CREATE}>
                    <Box marginTop={5}>
                      <Button loading={isLoading} type="submit">Submit</Button>
                    </Box>
                  </PermissionGate>
                )}
                <PermissionGate permission={PERMISSIONS.WHATSAPP_SEND_SHIPMENT_NOTIFICATION}>
                  <Box marginTop={5} display={formType === "edit" ? "block" : "none"}>
                    <Button loading={loadingMsg} onClick={() => sendWhatsAppMessage(id)}>Send WhatsApp Message</Button>
                  </Box>
                </PermissionGate>
                <PermissionGate permission={PERMISSIONS.SHIPMENTS_CREATE}>
                  <Box marginTop={5} display={formType === "edit" ? "block" : "none"}>
                    <Button onClick={() => {
                      navigate("../../Shipment/AddShipment");
                    }}>Add New Shipment</Button>
                  </Box>
                </PermissionGate>
              </Grid>
              <Grid xs={12} sm={4} alignContent={"end"}>
                <Box m={5} display={formType === "edit" ? "block" : "none"} alignItems={"end"}>
                  <ShipmentSticker shipments={[shipment]}></ShipmentSticker>
                </Box>
              </Grid>
            </Grid>
            <Box visibility={shipmentID != null ? "visible" : "hidden"} marginTop={1} marginBottom={3}>
              <Typography level="h4">Notifications</Typography>
              <DataGrid
                hideFooter={true}
                rows={notifications || []}
                columns={columns}
                loading={isLoading}
              />
            </Box>
            <Box visibility={shipmentID != null ? "visible" : "hidden"} marginTop={1} marginBottom={3}>
              <Typography level="h4">Payments</Typography>
              <DataGrid
                hideFooter={true}
                rows={shipment.payments || []}
                columns={getShipmentFormPaymentColumns()}
                loading={isLoading}
                sx={{ minHeight: 200 }}
              />
            </Box>
          </FormControl>
        </form>
      </Box>
      <Snackbar
        autoHideDuration={3000}
        open={successUpdate}
        variant={"soft"}
        color={"success"}
        onClose={(event, reason) => {
          if (reason === 'clickaway') {
            return;
          }
          setSuccessUpdate(false);
        }}
      >
        Shipment Updated Successfully
      </Snackbar>
      <Snackbar
        autoHideDuration={3000}
        open={failedUpdate}
        variant={"soft"}
        color={"danger"}
        onClose={(event, reason) => {
          if (reason === 'clickaway') {
            return;
          }
          setFailedUpdate(false);
        }}
      >
        {"Shipment Failed to Update, " + errorMessage}
      </Snackbar>
      <Snackbar
        autoHideDuration={3000}
        open={successSentMsg}
        variant={"soft"}
        color={"success"}
        onClose={(event, reason) => {
          if (reason === 'clickaway') {
            return;
          }
          setSuccessSentMsg(false);
        }}
      >
        WhatsApp Message sent Successfully
      </Snackbar>
      <Snackbar
        autoHideDuration={3000}
        open={failedSentMsg}
        variant={"soft"}
        color={"danger"}
        onClose={(event, reason) => {
          if (reason === 'clickaway') {
            return;
          }
          setFailedSentMsg(false);
        }}
      >
        WhatsApp Message sent Failed
      </Snackbar>
    </Box>
  );
}